import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { DocumentSvg } from './Document';

export const DocumentIcon = createIcon('document', DocumentSvg);
/**
 * @deprecated используйте DocumentIcon
 */
export const withDocumentIcon = withIcon('document', DocumentSvg);
